<template>
    <div class="card card-form">
        <!-- Toolbar -->
        <div class="card-header">
            <responsive>
                <div class="d-flex flex-nowrap">
                    <div class="btn-toolbar ml-auto">
                        <button class="btn btn-primary px-2 mr-1 d-lg-none" @click="filter.visible = !filter.visible">
                            <i class="fas fa-fw fa-filter" v-if="!filter.visible"></i>
                            <i class="fas fa-fw fa-times" v-if="filter.visible"></i>
                        </button>
                        <button class="btn btn-primary" @click="filterData()">
                            {{ $t('[[[Filtruj]]]') }}
                        </button>
                        <button class="btn btn-secondary" @click="resetFilter()">
                            {{ $t('[[[Resetuj]]]') }}
                        </button>
                    </div>
                </div>
            </responsive>
        </div>
        <div class="row no-gutters">
            <!-- Filtry -->
            <div class="col-lg-3 order-lg-last p-3 bg-light" :class="{'d-none d-lg-block': !filter.visible}">
                <b-form-group :label="$t('[[[Nazwa roli]]]')" :feedback="filter.$errors.first('roleName')" :state="filter.$errors.state('roleName')">
                    <b-form-input v-model="filter.roleName" type="text" name="roleName"></b-form-input>
                </b-form-group>
                <b-form-group :label="$t('[[[Data od]]]')" :feedback="filter.$errors.first('dateFromUtc')" :state="filter.$errors.state('dateFromUtc')">
                    <datetimepicker v-model="filter.dateFromUtc" type="datetime" />
                </b-form-group>
                <b-form-group :label="$t('[[[Data do]]]')" :feedback="filter.$errors.first('dateDueUtc')" :state="filter.$errors.state('dateDueUtc')">
                    <datetimepicker v-model="filter.dateDueUtc" type="datetime" />
                </b-form-group>
            </div>
            <!-- Tabela -->
            <div class="col-lg-9 p-3">
                <responsive>
                    <table class="table table-data table-striped table-hover">
                        <colgroup>
                            <col>
                            <col style="width:160px">
                            <col>
                        </colgroup>
                        <thead>
                            <tr>
                                <th><sort :pager="pager" @change="onSorting" header="RoleName">{{ $t('[[[Nazwa roli]]]') }}</sort></th>
                                <th><sort :pager="pager" @change="onSorting" header="DateCreatedUtc">{{ $t('[[[Data dodania]]]') }}</sort></th>
                                <th class="buttons"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in items" :key="item.id">
                                <td class="text-nowrap">
                                    <b-link :to="{name:'core-roles-edit', params: { id: item.id }}">{{item.roleName}}</b-link>
                                </td>
                                <td class="text-nowrap">{{item.dateCreatedUtc | datetime}}</td>
                                <td class="buttons">
                                    <b-button-group size="sm">
                                        <b-button variant="outline-primary" :to="{name:'core-roles-edit', params: { id: item.id }}" :title="$t('[[[Edytuj]]]')">
                                            <i class="fas fa-pencil-alt"></i>
                                        </b-button>
                                        <b-button variant="outline-danger" :id="`btn-delete-${item.id}`" :title="$t('[[[Usuń]]]')" :disabled="!item.meta.canDelete">
                                            <i class="fas fa-times"></i>
                                        </b-button>
                                    </b-button-group>
                                    <confirmation :message="$t('[[[Potwierdzenie usunięcia]]]')" :target="`btn-delete-${item.id}`" :value="item" @confirm="deleteItem" />
                                </td>
                            </tr>
                            <tr v-if="items.length == 0">
                                <td colspan="3" class="text-center">{{ $t('[[[Brak danych.]]]') }}</td>
                            </tr>
                        </tbody>
                    </table>
                </responsive>
            </div>
        </div>
        <!-- Przyciski -->
        <div class="card-footer">
            <responsive>
                <div class="d-flex flex-nowrap">
                    <router-link class="btn btn-primary mr-3" :to="{name:'core-roles-add'}" :disabled="!meta.canCreate">
                        <i class="fas fa-fw fa-plus"></i> {{ $t('[[[Dodaj rolę]]]') }}
                    </router-link>
                    <pagination :pager="pager" @change="filterData()" class="mb-0 mx-auto"></pagination>
                    <select v-model="pager.pageSize" @change="filterData()" class="form-control w-auto ml-3">
                        <option v-for="item in [10, 20, 50, 100]" :key="item" :value="item">{{item}}</option>
                    </select>
                </div>
            </responsive>
        </div>
    </div>
</template>

<script>
import RolesService from '@/services/core/RolesService';

export default
{
    data: function()
    {
        return {
            items: [],
            meta: {}
        };
    },

    store: {
        filter: 'modules.core.roles.filter',
        pager: 'modules.core.roles.pager'
    },

    created: function()
    {
        this.loadData();
    },

    methods: {
        async loadData()
        {
            try
            {
                let response = await RolesService.getList(this.filter, this.pager);
                this.pager.setTotalRows(response.data.totalRows);
                this.items = response.data.items;
                this.meta = response.data.meta;
            }
            catch (ex)
            {
                this.pager.setTotalRows(0);
                this.items = [];
                this.$log.debug(ex);
            }
        },

        async onSorting(sorting, order)
        {
            await this.loadData();
        },

        async deleteItem(item)
        {
            try
            {
                await RolesService.remove(item.id);
                this.$alert.success(this.$t('[[[Rola została usunięta.]]]'));
                await this.loadData();
            }
            catch (ex)
            {
                if (ex.code === 400)
                    this.$alert.warning(ex.message);

                this.$log.debug(ex);
            }
        },

        async filterData()
        {
            await this.loadData();
        },

        async resetFilter()
        {
            this.filter.reset();
            await this.loadData();
        }
    }
};
</script>
